/* ==========================================================================
   AutocompleteRxjs > Client > Prototype
   ========================================================================== */
/* Modules */
const { fromEvent } = require('rxjs');
const { filter } = require('rxjs/operators');
const { actions, types } = require('../store/actions');

const configuration = require('../config');

const {
    css: { valid: cssValid, error: cssError, active: cssActive }
} = configuration();

function startInput(instance) {
    const panel = instance;
    const { hooks = {}, config = {} } = instance;
    const { input: inputEl } = hooks;

    /* Extends actions */
    panel.actions = {
        ...panel.actions,
        resetStatus: () => panel.store.dispatch(actions.resetStatus()),
        setError: () => panel.store.dispatch(actions.setError()),
        setValid: () => panel.store.dispatch(actions.setValid()),
        syncValue: () => panel.store.dispatch(actions.syncValue()),
        toggleActive: () => panel.store.dispatch(actions.toggleActive())
    };

    /* Extends reactions */
    panel.reactions = {
        ...panel.reactions,
        setError: panel.store.subscribe((state, action) => {
            if (action.type !== types.SET_ERROR) return;

            panel.element.classList.remove(cssValid);
            panel.element.classList.add(cssError);
        }),
        setValid: panel.store.subscribe((state, action) => {
            if (action.type !== types.SET_VALID) return;

            panel.element.classList.remove(cssError);
            panel.element.classList.add(cssValid);
        }),
        resetStatus: panel.store.subscribe((state, action) => {
            if (action.type !== types.RESET_STATUS) return;

            panel.element.classList.remove(cssValid);
            panel.element.classList.remove(cssError);
        }),
        syncValue: panel.store.subscribe((state, action) => {
            if (action.type !== types.SYNC_VALUE) return;

            /* Data */
            const { value, error } = panel.store.select('autocomplete');
            const { text } = value || {};

            /* Don't sync input and clear */
            if (error && inputEl.value !== '') {
                panel.actions.clear();
                return;
            }

            /* Empty imput value and Clear */
            if (!text || inputEl.value === '') {
                inputEl.value = '';
                panel.actions.clear();
                return;
            }

            /* Restore stored value */
            if (text !== inputEl.value) inputEl.value = text;
        }),
        toggleActive: panel.store.subscribe((state, action) => {
            if (action.type !== types.TOGGLE_ACTIVE) return;

            /* Data */
            const { active } = panel.store.select('autocomplete');
            const { isAlternative } = config;

            /* is alternative, don't toggle */
            if (isAlternative) return;

            /* Label up */
            if (active) {
                panel.element.classList.add(cssActive);
                return;
            }

            /* Lobel down */
            panel.element.classList.remove(cssActive);
        })
    };

    /* Extends subscriptions */
    panel.subscriptions = {
        ...panel.subscriptions,
        focusIn: fromEvent(panel.hooks.input, 'focusin').subscribe(() => {
            const { active } = panel.store.select('autocomplete');

            const { selectionRange } = config;

            /* Tooggle input label */
            if (!active && !panel.config.isAlternative) panel.actions.toggleActive();

            if (!selectionRange) return;

            /* Select all content in input */
            panel.hooks.input.setSelectionRange(0, panel.hooks.input.value.length);
        }),
        focusOut: fromEvent(panel.hooks.input, 'focusout')
            .pipe(filter(() => !panel.store.select('autocomplete').openSuggestions))
            .subscribe(() => {
                panel.actions.syncValue();
            })
    };
}

module.exports = {
    startInput
};
